import { useMemo } from 'react'

import type { RecentHotelSearches } from '@/components/TripActivity/types'
import type { CityId, LOCATION_SEARCH_TYPE } from '@/types'

import useRecentSearchCard from './useRecentSearchCard'
import useRecommendations from './useRecommendations'

export default function useRecentSearchesFetched(
  cguid: string,
  appName: string,
  appVersion: string,
  signedIn: boolean,
) {
  const { data, isFetched: isRecentSearchCardFetched } = useRecentSearchCard(
    cguid,
    { appName, appVersion },
    ['STAY'],
    signedIn,
  )

  const cityIdList = useMemo<CityId[]>(
    () =>
      data
        .filter((item) => item.productType === 'STAY')
        .map((item) => ({ label: (item as RecentHotelSearches).cityId })),
    [data],
  )

  const { data: cityInfoList, isFetched: isCityInfoFetched } = useRecommendations(cityIdList)

  const isReady = isRecentSearchCardFetched && (cityIdList.length === 0 || isCityInfoFetched)

  const recentLocations = useMemo<LOCATION_SEARCH_TYPE[]>(
    () =>
      cityInfoList.map((item) => ({
        ...item,
        country: item.countryName,
        entered: '',
        highlightedName: null,
      })),
    [cityInfoList],
  )

  return [recentLocations, isReady] as const
}
